import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from './common-props';

const Banner = styled.header`
  display: block;
  background-color: #F1F3F8;
  width: 100%;
  z-index: 210;
  height: 150px;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: ${props => (props.theme.isMobileOrTablet ? '22px 20px 26px 20px' : '36px 0 40px 0')};

  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
  `};
  ${props => props.theme.isLarge && `
    width: 85%;
  `};
  ${props => props.theme.isXLarge && `
    width: 953px;
  `};
  ${props => props.theme.isXXLarge && `
    width: 1200px;
  `};
`;

const Name = styled.h1`
  color: ${props => props.theme.bodyColor};
  display: flex;
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  ${props => (props.theme.isMobileOrTablet ? `
    font-size: 34px;
    line-height: 44px;
    margin: 10px 0 10px 0;
  ` : `
    font-size: 40px;
    line-height: 52px;
    margin: 0;
  `)};
`;

const Desc = styled.p`
  color: ${props => props.theme.secondaryColorLight};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 14px;
  line-height: ${props => (props.theme.isMobileOrTablet ? 18 : 22)}px;
  margin: 0;
`;

export default function Header(props) {
  const common = commonProps();
  const {
    name, description,
  } = props;

  return (
    <ThemeProvider theme={common}>
      <Banner>
        <Container>
          <Name>{name}</Name>
          {description && <Desc>{description}</Desc>}
        </Container>
      </Banner>
    </ThemeProvider>
  );
}

Header.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Header.defaultProps = {
  description: null,
};
